import { useScrollTrigger } from '@mui/material';
import { AppBar, Box, Button, Toolbar } from '@mui/material';
import logo from '../../assets/hdrelay.png';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthenticationContext } from '../AuthenticationContext';
import { ApolloConsumer } from '@apollo/client';

interface Props {
  children: React.ReactElement;
}

function ElevationScroll(props: Props) {
  const { children } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

export default function AppHeader() {
  const history = useHistory();
  const { authorized, removeToken } = useContext(AuthenticationContext);

  return (
    <>
      <ElevationScroll>
        <AppBar>
          <Toolbar>
            {authorized && (
              <Box display="flex" flexDirection="row" style={{ width: '100%' }}>
                <Box flexGrow={1}>
                  <img src={logo} style={{ height: '45px' }} />
                </Box>
                <Box alignItems="center" display="flex">
                  <Box>
                    <Button style={{ color: 'white' }} onClick={() => history.push('/')}>
                      Cameras
                    </Button>
                  </Box>
                </Box>
                <Box alignItems="center" display="flex">
                  <Box>
                    <Button style={{ color: 'white' }} onClick={() => history.push('/account')}>
                      Account
                    </Button>
                  </Box>
                </Box>
                <Box alignItems="center" display="flex">
                  <Box>
                    <ApolloConsumer>
                      {(client) => (
                        <Button
                          style={{ color: 'white' }}
                          onClick={() => {
                            removeToken();
                            client.resetStore();
                            history.push('/');
                          }}
                        >
                          Logout
                        </Button>
                      )}
                    </ApolloConsumer>
                  </Box>
                </Box>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <Toolbar id="back-to-top-anchor" />
    </>
  );
}
